import { Button, Modal } from 'native-base';
import React, { useState } from 'react';
import { Icon } from '../../Common/components/Icon';
import { faBookMedical } from '@fortawesome/pro-solid-svg-icons/faBookMedical';
import { DoctorMHRDischargeModal } from './DoctorMHRDischargeModal';

interface IDoctorMHRDischargeProp {
  customerID: string;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorMHRDischarge({ customerID, onLoadDocumentCLicked }: IDoctorMHRDischargeProp) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        leftIcon={<Icon icon={faBookMedical} />}
        size={'sm'}
        variant={'outline'}
        onPress={() => setShowModal(true)}
      >
        My Health Record - Latest Discharge Summary View
      </Button>

      <Modal isOpen={showModal} size={'full'} onClose={() => setShowModal(false)}>
        {showModal && <DoctorMHRDischargeModal customerID={customerID} onLoadDocumentCLicked={onLoadDocumentCLicked} />}
      </Modal>
    </>
  );
}
